import { RouterModule, Routes } from '@angular/router';

// Components
import { LoginComponent } from './login/login.component';
import { RegisterComponent } from './register/register.component';
import { RestorePasswordComponent } from './restore-password/restore-password.component';
import { RestorePasswordConfirmComponent } from './restore-password/restore-password-confirm/restore-password-confirm.component';
import { TutoriaComponent } from './tutoria/tutoria.component';
import { PagesComponent } from './pages/pages.component';
import { NopagefoundComponent } from './shared/nopagefound/nopagefound.component';

// Guards
import { loginGuard } from './services/guards/login.guard';
import { selectUserTypeGuard } from './services/guards/select-user-type.guard';
import { isLoginGuard } from './services/guards/is-login.guard';
import { redirectFromHomeGuard } from './services/guards/redirect-from-home.guard';
import { HomeComponent } from './home/home.component';
import { LogOutComponent } from './log-out/log-out.component';
import { DeleteAccountComponent } from './delete-account/delete-account.component';
import { CompleteDeleteAccountComponent } from './complete-delete-account/complete-delete-account.component';
import { isLTIRouteMatch } from './services/guards/is-lti-route.guard';
import { provideTranslocoScope } from '@jsverse/transloco';
import {
  ltiTranslocoResolver,
  pagesTranslocoResolver,
} from './services/guards/transloco-scope-resolver.resolver';

const appRoutes: Routes = [
  {
    path: 'sign-in',
    canActivate: [isLoginGuard],
    component: LoginComponent,
    data: { tituloES: 'Iniciar sesión', tituloEN: 'Sign in' },
  },
  {
    path: 'sign-in/:apple-response',
    canActivate: [isLoginGuard],
    component: LoginComponent,
    data: { tituloES: 'Iniciar sesión', tituloEN: 'Sign in' },
  },
  {
    path: 'restore-password',
    canActivate: [isLoginGuard],
    component: RestorePasswordComponent,
    data: { tituloES: 'Olvidaste la contraseña', tituloEN: 'Forgot password' },
  },
  {
    path: 'restore-password/confirm/:hash',
    canActivate: [isLoginGuard],
    component: RestorePasswordConfirmComponent,
    data: {
      tituloEs: 'Confirmación de correo',
      tituloEn: 'Email confirmation',
    },
  },
  {
    path: 'sign-up',
    component: RegisterComponent,
    canActivate: [selectUserTypeGuard],
    data: { tituloES: 'Registrarse', tituloEN: 'Sign up' },
  },
  {
    path: 'home',
    canActivate: [loginGuard],
    component: HomeComponent,
  },
  {
    path: 'log-out',
    canActivate: [loginGuard],
    component: LogOutComponent,
  },
  {
    path: 'request-account-data-deletion',
    component: DeleteAccountComponent,
  },
  {
    path: 'complete-account-data-deletion',
    component: CompleteDeleteAccountComponent,
  },
  //* TutorIA *//
  {
    path: 'tutoria',
    component: TutoriaComponent,
    data: { tituloES: null, tituloEN: null },
  },
  {
    path: '',
    canMatch: [isLTIRouteMatch],
    providers: [provideTranslocoScope('lti')],
    resolve: { ltiReady: ltiTranslocoResolver },
    loadChildren: () => import('./lti/lti.routes').then((m) => m.LTI_ROUTES),
  },
  {
    path: '',
    component: PagesComponent,
    canActivate: [loginGuard],
    resolve: { pagesReady: pagesTranslocoResolver },
    loadChildren: () =>
      import('./pages/pages.module').then((m) => m.PagesModule),
  },
  {
    path: '**',
    canActivate: [redirectFromHomeGuard],
    component: NopagefoundComponent,
  },
];

/**
 * @ignore
 */
export const APP_ROUTES = RouterModule.forRoot(appRoutes, {
  bindToComponentInputs: true,
});
